<template>
     <div class="sessionBox">
            <div :class="isMobile?'':'session'">
                <div :class="isMobile?'centerTitles':'centerTitle'">业务范围</div>
                <div :class="isMobile?'swiperC':'swiper-container'">
                    <div class="swiper-wrapper">
                        <div :class="isMobile?'slideM':'swiper-slide'">
                            <div class="item" @click="jumpTo('/businessScope/earlierConsultation')">
                                <div class="introductionPic introductionPic01"></div>
                                <div class="title">投资咨询</div>
                                <div class="introduction">
                                    <p>集团投资咨询业务开展于2004年，经过多年的 潜心发展，如今已成为资信水平优良，技术力量雄厚，业绩能力突出的综合型咨询业务。拥</p>
                                    <p>有综合甲级；建筑，电子、信息工程...</p>
                                </div>
                            </div>
                            <div class="item" @click="jumpTo('/businessScope/costConsultation')">
                                <div class="introductionPic introductionPic03"></div>
                                <div class="title">造价咨询</div>
                                <div class="introduction">
                                    <p>集团造价咨询业务开展于2003年，并于2005年 在业内取得工程造价咨询甲级资质。服务过程涵盖了项目决策阶段、招投标阶段、施工</p>
                                    <p>阶段、竣工阶段等项目全生命周期...</p>
                                </div>
                            </div>
                            <div class="item" @click="jumpTo('/businessScope/biddingAgent')">
                                <div class="introductionPic introductionPic02"></div>
                                <div class="title">招标采购</div>
                                <div class="introduction">
                                    <p>招标采购业务是集团最早开展的业务板块，早 在2000年集团成立之初就作为主营业务发展至今。集团公司也是省内最早一批取得工程建设</p>
                                    <p>之一</p>
                                    <p>甲级、政府采购甲级、中央投资甲级...</p>
                                </div>
                            </div>
                        </div>
                        <div :class="isMobile?'slideM':'swiper-slide'">
                            <div class="item" @click="jumpTo('/businessScope/projectManagement')">
                                <div class="introductionPic introductionPic05"></div>
                                <div class="title">管理咨询</div>
                                <div class="introduction">
                                    <p>集团管理咨询业务开展于2001年，是集合了代 建、项目管理总承包模式（PMC，决策－执行）、项目管理模式(决策－执行)、项目管理</p>
                                    <p>模式(一体化)以及咨询顾问等管理模式的...</p>
                                </div>
                            </div>
                            <div class="item" @click="jumpTo('/businessScope/consultationBusiness')">
                                <div class="introductionPic introductionPic08"></div>
                                <div class="title">全咨业务</div>
                                <div class="introduction">
                                    <p>多年来，集团公司持续改进全咨业务流程，不断完善全咨业务体系，完成了很多影响广泛的全过程工程咨询项目，其中典型的案例有雄县</p>
                                    <p>城区雄州路雨污分流改造工程全过程咨询...</p>
                                </div>
                            </div>
                            <div class="item" @click="jumpTo('/businessScope/BIMApplication')">
                                <div class="introductionPic introductionPic06"></div>
                                <div class="title">数字化应用</div>
                                <div class="introduction">
                                    <p>集团提出了“数字化赋能全过程工程咨询”的战略目标，并在此规划下积极开展数字化应用，应用自主研发的OA、CRM、PMO</p>
                                    <p>等平台</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
    export default{
        data(){
            return{

            }
        },
        methods:{
            jumpTo(path,type){
                if(type==1){
                    window.location.assign('/mediaCenter/companyNews')
                }else if(type==2){
                    window.location.assign('/mediaCenter/IndustryNews')
                }else{
                    window.location.assign(path)
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .sessionBox{
        display: flex;
        justify-content: center;
    }
    .session {
        width: 1200px;
    }
    .swiper-container {
        margin-top: 68px;
        background: #F8F8F8;
    }
    .swiperC{
        margin-top: 20px;
    }
    .swiper-slide {
        display: flex;
    }
    .slideM{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .swiper-slide .item {
        user-select: none;
        cursor: pointer;
        color: #333333;
        width: 380px;
        height:436px;
        background: white;
        box-shadow: 0px 0px 7px 1px rgba(38,115,231,0.15);
        margin-right: 30px;
        margin-bottom: 30px;
        border-radius: 10px;
    }
    .swiper-slide .item:last-child {
        margin-right: 0;
    }
    .slideM .item {
        user-select: none;
        color: #333333;
        width: 380px;
        height:436px;
        margin: 0 auto;
        background: white;
        box-shadow: 0px 0px 7px 1px rgba(38,115,231,0.15);
        margin-bottom: 30px;
        border-radius: 10px;
    }
    .introductionPic {
        width: 380px;
        height: 206px;
        background-position: center;
        background-size: cover;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    .introductionPic01 {
        background: url('../../../assets/index/businessIntroduction001.png');
    }
    .introductionPic02 {
        background-image: url('../../../assets/index/businessIntroduction002.png');
    }
    .introductionPic03 {
        background-image: url('../../../assets/index/businessIntroduction003.png');
    }
    .introductionPic04 {
        background-image: url('../../../assets/index/businessIntroduction004.png');
    }
    .introductionPic05 {
        background-image: url('../../../assets/index/businessIntroduction005.png');
    }
    .introductionPic06 {
        background-image: url('../../../assets/index/businessIntroduction006.png');
    }
    .introductionPic07 {
        background-image: url('../../../assets/index/businessIntroduction007.png');
    }
    .introductionPic08 {
        background-image: url('../../../assets/index/businessIntroduction008.png');
    }
    .introductionPic09 {
        background-image: url('../../../assets/index/businessIntroduction009.png');
    }
    .title {
        margin-top: 30px;   
        font-size: 21px;
        font-weight: bold;
        padding: 0 24px;
    }
    .introduction {
        margin-top: 20px;
        font-size: 16px;
        padding: 0 24px;
        line-height: 30px;
    }
    .introduction p:first-child{
        text-align: justify;
        text-align-last: justify;
    }
    .centerTitle {
        text-align: center;
        margin-top: 68px;
        font-size: 36px;
        color: #333333;
    }
    .centerTitles{
        text-align: center;
        margin-top: 20px;
        font-size: 28px;
        color: #333333;
    }
</style>